// 🔩 Base
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// 🧱 Components
import CpmClientHeader from 'components/header/CpmClientHeader';
import CpmClientFooter from 'components/footer/CpmClientFooter';

// 🖼️ Context
import { CpmClientContext } from 'components/misc/Contexts';

const MAX_WIDTH_CONTENT = '1000px';
const MOBILE_WIDTH = '95vw';
const contentWidth = `min(${MOBILE_WIDTH}, ${MAX_WIDTH_CONTENT})`;

const CpmClientTemplate = ({
  displayChildren, children, hideLogo, handleFormTypeChange,
}) => {
  const [showBookButton, setShowBookButton] = useState(false);

  return (
    <CpmClientContext.Provider value={{ showBookButton, setShowBookButton, handleFormTypeChange }}>
      <CpmClientHeader hideLogo={hideLogo} handleFormTypeChange={handleFormTypeChange} />
      <div
        className="d-flex flex-column justify-content-center"
        style={{
          margin: '6lvh auto',
          width: contentWidth,
          flexGrow: 1,
        }}
      >
        {displayChildren && children}
      </div>
      <CpmClientFooter />
    </CpmClientContext.Provider>
  );
};

CpmClientTemplate.propTypes = {
  displayChildren: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  hideLogo: PropTypes.bool,
  handleFormTypeChange: PropTypes.func,
};

CpmClientTemplate.defaultProps = {
  displayChildren: true,
  hideLogo: false,
  handleFormTypeChange: null,
};

module.exports = CpmClientTemplate;



// WEBPACK FOOTER //
// ./components/templates/apps/CpmClientTemplate.js